import { render, staticRenderFns } from "./ConsolidatedFeeReport.vue?vue&type=template&id=20b46a9f&scoped=true"
import script from "./ConsolidatedFeeReport.vue?vue&type=script&lang=js"
export * from "./ConsolidatedFeeReport.vue?vue&type=script&lang=js"
import style0 from "./ConsolidatedFeeReport.vue?vue&type=style&index=0&id=20b46a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b46a9f",
  null
  
)

export default component.exports